import { RunDetailFunction } from '@/Pages/Run/components/RunDetailsFunctions';
import { PromptTool, isOpenAITool } from '@/utils/ai-tools';

import { JsonMessageDiff } from './Diffs';
import { GetToolDiffsArgs, StoredToolDiffsRecord } from './types';

export const CommitTools = ({
  commitId,
  showDiff,
  tools,
  previousTools,
  getToolDiffs,
}: {
  commitId: string;
  showDiff: boolean;
  tools: PromptTool[];
  previousTools: PromptTool[];
  getToolDiffs: (args: GetToolDiffsArgs) => StoredToolDiffsRecord;
}) => {
  const { toolDiffs } = getToolDiffs({
    commitId,
    previousCommitTools: previousTools,
    currentCommitTools: tools,
  });

  return (
    <div className="flex flex-col gap-2">
      {showDiff
        ? toolDiffs.map((d, i) => (
            <JsonMessageDiff diffs={d} title="Tool" key={i} />
          ))
        : tools.map((tool) => (
            <div className="rounded-md bg-secondary p-2">
              <RunDetailFunction
                function={isOpenAITool(tool) ? tool.function : tool}
                used={false}
              />
            </div>
          ))}
    </div>
  );
};
